<template>
  <div class="page-wrapper">
    <jump-header></jump-header>
    <div class="page-body" style="padding-top: 60px">
      <div class="program-header">
        <img :src="program.pictureUrl" />
        <div class="program-header-center">
          <span class="program-header-center-title">{{ program.name }}</span>
          <span class="program-header-center-desc">
            <i class="v-icon-play-line" />
            <span>{{ program._clickSum }}</span>
          </span>
        </div>
      </div>
    </div>
    <van-tabs
      v-model:active="currentIndex"
      sticky
      offset-top="45px"
      :line-width="20"
      style="margin-top: 20px"
      title-active-color="black"
      @click="changeTab"
      ref="tabsRef"
    >
      <van-tab
        v-for="(item, index) in tabList"
        :title="item.label"
        :key="index"
      >
        <div
          class="program-item"
          v-for="item in dataList"
          :key="item.id"
          :class="{ 'scroll-item': item.livingType === 1 }"
          @click="handleClickProgramItem(item)"
        >
          <img :src="item.pictureUrl" />
          <div class="program-item-center">
            <div class="program-item-center-title">{{ item.name }}</div>
            <div class="program-item-center-desc">
              <div
                :class="{
                  'type-living': item.livingType === 1,
                  'type-feature': item.liveName === '预约',
                  'type-appointment': item.liveName === '已预约',
                }"
                class="program-item-center-desc-type"
              >
                {{ item.liveName }}
              </div>
              <span>{{ item.startTime }}-{{ item.endTime }}</span>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { Toast } from "vant";
import wxSdk from "@/http/wxApi.js";
import { useRoute, useRouter } from "vue-router";
import moment from "moment";
import { defineComponent, onMounted, ref } from "vue";
import JumpHeader from "@/components/Base/JumpHeader";
import {
  queryRadioStationAndProgramByCode,
  queryAllProgramMenuPool,
} from "@/http/api";

export default defineComponent({
  name: "SevenDaysRecord",
  components: {
    JumpHeader,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const tabList = ref([]);
    const program = ref({});
    const dataList = ref([]);
    const tabsRef = ref(null);
    const currentIndex = ref(7);
    const radioStationCode = ref("");

    const getTabListItem = () => {
      for (let index = -7; index < 2; index++) {
        const ob = { value: "", label: "" };
        ob.value = moment().add(index, "days").format("YYYY-MM-DD");
        ob.label = moment().add(index, "days").format("MM-DD");
        if (index === 0) {
          ob.label = "今天";
        } else if (index === 1) {
          ob.label = "明天";
        }
        tabList.value.push(ob);
      }
      currentIndex.value = tabList.value.length - 2;
      radioStationCode.value = route.query.radioStationCode;
      getRadioMenu(tabList.value[currentIndex.value].value);
    };

    const getRadioMenu = async (startDate) => {
      tabsRef.value.scrollTo(currentIndex.value);
      const result = await queryAllProgramMenuPool({
        startDate: startDate,
        radioStationCode: radioStationCode.value,
      });
      dataList.value = result.data;
      let date = new Date();
      let hours =
        date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
      let mins =
        date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
      let nowTime = `${hours}:${mins}`;
      let nowDate = moment().format("YYYY-MM-DD");
      dataList.value.forEach((v, i) => {
        // 0 回放 1：直播 2：预约
        let livingType = 0;
        let liveName = "";
        if (
          v.startTime < nowTime &&
          nowTime < v.endTime &&
          nowDate === v.startDate
        ) {
          livingType = 1;
          liveName = "直播";
        } else if (
          nowDate > v.startDate ||
          (nowDate === v.startDate && nowTime > v.endTime)
        ) {
          livingType = 0;
          liveName = "回放";
        } else if (
          nowDate < v.startDate ||
          (nowDate === v.startDate && nowTime < v.endTime)
        ) {
          livingType = 2;
          liveName = "预约";
        }
        v.livingType = livingType;
        v.liveName = liveName;
      });
      setTimeout(() => {
        let livingItem = document.querySelector(".scroll-item");
        if (livingItem) {
          livingItem.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 300);
    };

    function changeTab(name) {
      let startDate = tabList.value[name].value;
      getRadioMenu(startDate);
    }

    const handleClickProgramItem = (item) => {
      if (item.liveName === "回放") {
        router.push({
          name: "LivingDetail",
          query: {
            playType: "playRecord",
            programId: item.liveId,
          },
        });
      } else if (item.liveName === "直播") {
        router.push({
          name: "LivingDetail",
          query: {
            code: item.radioStationCode,
          },
        });
      } else {
        Toast.fail("该节目暂未开始");
      }
    };

    // 获取频率详情
    const getProgramInfoByCode = async () => {
      const { data } = await queryRadioStationAndProgramByCode({
        radioStationCode: radioStationCode.value,
      });
      if (data.code === 1) {
        program.value = data.data;
        program.value._clickSum = fixNumToBig(program.value.clickSum);
      }
    };

    const fixNumToBig = (val) => {
      if (val > 10000) {
        return `${(val / 10000).toFixed(2)}万`;
      }
      return val;
    };

    const wxShare = () => {
      const _program = program.value;
      wxSdk.getJSSDK({
        title: _program.name,
        desc: _program.information,
        linkurl: `https://app.gztv.com/hcfmshare/#/SevenDaysRecord?radioStationCode=${_program.code}`,
        img: _program.pictureUrl,
      });
    };

    onMounted(async () => {
      getTabListItem();
      await getProgramInfoByCode();
      wxShare();
    });

    return {
      tabsRef,
      tabList,
      program,
      dataList,
      currentIndex,
      changeTab,
      handleClickProgramItem,
    };
  },
});
</script>

<style lang="scss" scoped>
.page-wrapper {
  max-width: 450px;
  margin: 0 auto;
  background: #f9f9f9;
}
.program-header {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 13px;
  padding-top: 10px;
  max-width: 450px;
  margin: 0 auto;

  img {
    width: 90px;
    height: 90px;
    border-radius: 4px;
    box-shadow: 2px 4px 6px rgba(0, 0, 0, 0.09);
    border: 1px solid rgba(0, 0, 0, 0.05);
    box-sizing: border-box;
  }

  &-center {
    display: flex;
    flex: 1;
    flex-direction: column;
    height: 90px;
    justify-content: center;
    padding-left: 10px;

    &-title {
      font-size: 18px;
      color: #111;
      font-weight: bold;
      padding-bottom: 20px;
    }

    &-desc {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #666;

      .v-icon-play-line {
        margin-right: 5px;
        font-size: 14px;
      }
    }
  }
}

.program-item {
  display: flex;
  align-items: center;
  height: 90px;
  margin-left: 13px;
  width: calc(100% - 13px);
  border-bottom: 1px solid #e9e9e9;

  img {
    width: 60px;
    min-width: 60px;
    height: 60px;
    border-radius: 4px;
  }

  &-center {
    display: flex;
    flex-direction: column;
    padding-left: 10px;
    height: 50px;
    justify-content: space-between;

    &-title {
      font-size: 14px;
      color: #111;
      font-weight: bold;
    }

    &-desc {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #666;

      &-type {
        margin-right: 30px;
        padding: 3px 6px;
        background: #999;
        color: #fff;
        border-radius: 4px;
      }
    }
  }
}

.type-living {
  color: #fff;
  padding: 3px 5px;
  background: #e73828;
  color: #fff;
  border-radius: 4px;
}

.type-feature {
  padding: 3px 6px;
  background: #999;
  color: #fff;
  border-radius: 4px;
}

.type-appointment {
  background: #ff9900;
}
</style>
